import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@ferris/react/components/cards';
import defaultHeroImage from '../../assets/images/lyp-hero.svg';

export const Masthead = ({
    children
}) => (
    <div className="ulx-header">
        <div className="ulx-header__hero">
            <img src={defaultHeroImage} alt="" />
        </div>

        <div className="ulx-header__box">
            <Card
                elevation="0"
                theme="default"
            >
                <CardContent
                    collapsePadding={false}
                    separatorBottom={false}
                    separatorTop={false}
                >
                    {children}
                </CardContent>
            </Card>
        </div>
    </div>
);

Masthead.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired
};

export default Masthead;
